module.exports = {
  CREATED: 'created', //        F2M status to start
  PENDING: 'pending', //        En attente
  ACTIVATED: 'activated', //    Actif
  CANCELLING: 'cancelling', //  F2M status to cancel
  CANCELLED: 'cancelled', //    Résilié
  EXPIRED: 'expired', //         Échu
};
